import React, { Component, Fragment } from 'react';
import '@xo-union/tk-ui-typography/lib/globals.css';
import GuestSearchField from '~/glm/components/guest-list/header/guest-search-field';
import PageHeaderIA from '~/glm/components/shared/layout/page-header-ia';
import BulkSelectToolbar from '~/glm/components/guest-list/bulk-select-toolbar';
import AnalyticsStore from '~/glm/models/analytics-store';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import GuestListStore from '~/glm/models/guest-list-store';
import UserStore from '~/glm/models/user-store';
import GdsHouseholdCollection from '~/glm/models/gds/gds-household-collection';
import Card from '~/glm/components/guest-list/cards/card';
import OverviewRsvpFilterDropdown from './overview-rsvp-filter-dropdown';
import EventCollection from '~/glm/models/gds/event-collection';
import OverviewFirstTimeMessage from '~/glm/components/guest-list/cards/overview-first-time-message';
import SelectedGuestsDropdowns from '~/glm/components/guest-list/header/selected-guests-dropdown';
import AddGuestButton from '~/glm/components/guest-list/header/add-guest-button';
import DownloadListButton from '~/glm/components/guest-list/header/download-list-button';
import styles from './header.scss';
import ZeroState from '~/glm/components/zero-state';
import GuestCountModal from './guest-count-modal';

@observer
class OverviewHeader extends Component {
  constructor(props) {
    super(props);
    this.state = { addGuestCountModalOpen: false };
  }

  filterOn = (filter, event) => {
    const { gdsUiState, analyticsStore } = this.props;
    gdsUiState.setRsvpFilter(filter, event);
    analyticsStore.track('Dashboard Interaction', { action: 'Filter by RSVP' });
  };

  get activeFilter() {
    const { gdsUiState } = this.props;
    const { rsvpFilter, filter, addressFilter } = gdsUiState;
    return !!(rsvpFilter || filter || addressFilter);
  }

  clearFilters = () => {
    const { gdsUiState, analyticsStore } = this.props;

    analyticsStore.track('Dashboard Interaction', {
      action: 'clear results',
    });

    gdsUiState.setRsvpFilter('', null);
    gdsUiState.setAddressFilter(false);
    gdsUiState.setFilter('');
  };

  showDropdownAndSearchBar = () => {
    const { gdsUiState, gdsHouseholds } = this.props;

    return !gdsUiState.isBulkSelecting && gdsHouseholds.size;
  };

  resultClear = () => {
    const { gdsUiState } = this.props;
    if (this.activeFilter) {
      const singular = gdsUiState.filterResultsLength === 1;
      return (
        <div className={styles.filterHeading}>
          <span>
            {gdsUiState.filterResultsLength} RESULT{singular ? '' : 'S'}{' '}
          </span>
          <span onClick={this.clearFilters} className={styles.clear}>
            clear
          </span>
        </div>
      );
    }
  };

  closeModal = () => {
    this.setState({ addGuestCountModalOpen: false });
  };

  openAddGuestCountModal() {
    const { analyticsStore } = this.props;
    this.setState({ addGuestCountModalOpen: true });
    analyticsStore.track('Dashboard Interaction', {
      action: 'add total guest count initiated',
      source: 'glm header',
    });
  }

  addTotalGuestCount = guestRange => {
    const { userStore, analyticsStore } = this.props;
    if (userStore.guestRange !== guestRange) {
      userStore.updateGuestRange(guestRange).then(({ wedding }) => {
        if (wedding.guest_range === guestRange) {
          analyticsStore.track('Dashboard Interaction', {
            action: 'add total guest count success',
            source: 'glm header',
            guest_range: guestRange,
          });
        }
      });
    }
    this.closeModal();
  };

  render_overviewHeading = () => {
    const { guestListStore } = this.props;

    return (
      <div className={styles.overviewHeading}>
        <span>TOTAL HOUSEHOLDS:</span>
        <span className={styles.number}>{guestListStore.totalHouseholdCount}</span>
        <span className={styles.divider}> | </span>
        <span>TOTAL GUESTS:</span>
        <span className={styles.number}>{guestListStore.totalGuestCount}</span>
        <span className={styles.divider}> | </span>
        <span>TOTAL EVENTS:</span>
        <span className={styles.number}>{guestListStore.overviewEventCount}</span>
      </div>
    );
  };

  heading = () => {
    const { gdsUiState, gdsHouseholds, analyticsStore, showZeroState } = this.props;

    if (gdsHouseholds.size) {
      if (gdsUiState.isBulkSelecting || this.activeFilter) {
        // NOTE: need to maintain header height so may render empty div
        return <div className={styles.overviewHeading}>{this.activeFilter && this.resultClear()}</div>;
      } else {
        return <>{this.render_overviewHeading()}</>;
      }
    } else if (showZeroState) {
      return <ZeroState gdsUiState={gdsUiState} analyticsStore={analyticsStore} />;
    } else {
      return (
        <Card>
          <OverviewFirstTimeMessage gdsUiState={gdsUiState} analyticsStore={analyticsStore} />
        </Card>
      );
    }
  };

  subheading = () => {
    const { gdsHouseholds, events, gdsUiState } = this.props;
    if (!gdsHouseholds.size) return null;

    if (gdsUiState.isBulkSelecting) {
      return (
        <div className={styles.headerTools}>
          <BulkSelectToolbar
            dropdownComponent={updateGuests => (
              <SelectedGuestsDropdowns handleClick={updateGuests} events={events} gdsUiState={gdsUiState} />
            )}
          />
        </div>
      );
    }

    return (
      <div className={styles.headerTools}>
        {this.showDropdownAndSearchBar() && (
          <>
            <GuestSearchField />
            <OverviewRsvpFilterDropdown
              events={events}
              gdsUiState={gdsUiState}
              rsvpFilterFunc={this.filterOn}
              label={'Filter By'}
            />
          </>
        )}
      </div>
    );
  };

  addGuestDownloadList = () => {
    const { gdsHouseholds, gdsUiState, analyticsStore } = this.props;

    const shouldShow = !gdsUiState.isBulkSelecting && !this.activeFilter && gdsHouseholds.size > 0;
    if (!shouldShow) return null;

    return (
      <div className={styles.leftAlign}>
        <DownloadListButton />
        <AddGuestButton analyticsStore={analyticsStore} gdsUiState={gdsUiState} />
      </div>
    );
  };

  render() {
    const { gdsUiState, userStore, gdsHouseholds } = this.props;
    if (!gdsUiState.allGuestsView) return null;
    const { guestRange } = userStore;
    const showingFirstTimeCard = !gdsHouseholds.size;

    return (
      <Fragment>
        <PageHeaderIA
          heading={this.heading()}
          subHeading={this.subheading()}
          firstTimeCard={showingFirstTimeCard}
          showZeroState={this.props.showZeroState}
        >
          {this.addGuestDownloadList()}
        </PageHeaderIA>
        <GuestCountModal
          guestCount={guestRange}
          open={this.state.addGuestCountModalOpen}
          setClose={this.closeModal}
          onSuccess={this.addTotalGuestCount}
        />
      </Fragment>
    );
  }
}

OverviewHeader.propTypes = {
  gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
  gdsHouseholds: PropTypes.instanceOf(GdsHouseholdCollection),
  analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  guestListStore: PropTypes.instanceOf(GuestListStore).isRequired,
  userStore: PropTypes.instanceOf(UserStore).isRequired,
  events: PropTypes.instanceOf(EventCollection).isRequired,
  showZeroState: PropTypes.bool,
};

export default OverviewHeader;
